import FamilleArticleForm from "@features/creation/famille-articles/components/FamilleArticleForm";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { PlusCircle } from "lucide-react";

export const Route = createFileRoute("/_app/creation/familleArticles/create")({
  loader: requirePermission(PERMISSIONS.CREATION.FAMILLE_ARTICLES.CREATE),
  staticData: {
    title: "Nouvelle famille d'articles",
    icon: PlusCircle,
    permission: PERMISSIONS.CREATION.FAMILLE_ARTICLES.CREATE,
    section: "Creation",
    showInBreadcrumb: true,
  },
  component: CreateFamilleArticlePage,
});

function CreateFamilleArticlePage() {
  return (
    <div className="max-w-5xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">Nouvelle famille d'articles</h1>
        <p className="text-sm text-base-content/60">Créer une nouvelle famille d'articles</p>
      </div>
      <FamilleArticleForm />
    </div>
  );
}
